import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectStyles } from 'injectStyles';
import * as analytics from 'analytics';
import * as cssVariable from 'cssVariables';
import FEEDBACK_CONTENT from './FaqAnswer.const';
import ContentTypeComponent from 'components/ContentTypeComponent';
import Button from 'components/Button';
import ButtonTypes from 'components/Button/Button.const';

class FaqAnswer extends PureComponent {
  static propTypes = {
    answerContent: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
    hasFeedback: PropTypes.bool,
    history: PropTypes.object.isRequired,
    questionSlug: PropTypes.string.isRequired,
    question: PropTypes.string.isRequired,
  };

  static defaultProps = {
    hasFeedback: true,
  };

  state = {
    feedbackGiven: false,
  };

  giveFeedback = (helpful) => () => {
    const { question } = this.props;
    this.setState({ feedbackGiven: true });
    analytics.faqFeedback(helpful ? 'ja' : 'nee', question);
    if (helpful === false) this.props.history.push('/contact');
  };

  render() {
    const { answerContent, classes, hasFeedback } = this.props;
    const { feedbackGiven } = this.state;
    return (
      <Fragment>
        {answerContent &&
          answerContent.map(({ id, contentTypeId, ...props }) => (
            <div key={id}>
              <ContentTypeComponent contentTypeId={contentTypeId} {...props} />
            </div>
          ))}
        {hasFeedback && !feedbackGiven && (
          <Fragment>
            <h4 className={classes.feedback}>{FEEDBACK_CONTENT.QUESTION}</h4>
            <div className={classes.btnWrapper}>
              <Button type={ButtonTypes.PRIMARY} onClick={this.giveFeedback(false)} text={FEEDBACK_CONTENT.BUTTON_NO} />
              <Button onClick={this.giveFeedback(true)} type={ButtonTypes.PRIMARY} text={FEEDBACK_CONTENT.BUTTON_YES} />
            </div>
          </Fragment>
        )}
        {feedbackGiven && <h4 className={classes.feedback}>{FEEDBACK_CONTENT.CONFIRMATION}</h4>}
      </Fragment>
    );
  }
}
const styles = (theme) => ({
  btnWrapper: {
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  feedback: {
    fontSize: 18,
    lineHeight: 1.33,
    fontWeight: cssVariable.fontWeights.regular,
    color: theme.palette.text.primary,
  },
});

export default injectStyles(styles)(FaqAnswer);
